import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { Store } from 'redux'

import App from './App'
import { isDevOrLocal } from './modules/config/helpers'
import createAppStore from './modules/core/store'
import { RootState } from './modules/core/store/root.reducer'
import { MockInterceptor, CareMockDB } from './modules/mockDB'

import { startAppCore } from '~/appCore'

async function startApp() {
  const appDeps = await startAppCore()

  await appDeps.authService.init()

  if (isDevOrLocal(appDeps.runtimeConfig.environment)) {
    // Init axios interceptor
    MockInterceptor.initInterceptor(CareMockDB)
  }

  const { store, persistor } = createAppStore(appDeps, undefined)
  ReactDOM.render(
    <Provider store={(store as unknown) as Store<RootState>}>
      <App appDeps={appDeps} persistor={persistor} />
    </Provider>,
    document.getElementById('root'),
  )
}

startApp()
